// Simple outbox for device settings: stores the latest payload to sync later
// Uses localStorage for small payloads

const KEY = 'settings_outbox_latest';

function getStorage() {
  try {
    return window.localStorage;
  } catch (e) {
    return null;
  }
}

export function enqueueSettings(payload) {
  const storage = getStorage();
  if (!storage) return false;
  try {
    storage.setItem(KEY, JSON.stringify({ payload, ts: Date.now() }));
    return true;
  } catch (e) {
    console.warn('[settingsOutbox] Failed to enqueue settings:', e);
    return false;
  }
}

export function getQueuedSettings() {
  const storage = getStorage();
  if (!storage) return null;
  try {
    const raw = storage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.payload || null;
  } catch (e) {
    console.warn('[settingsOutbox] Failed to read queued settings:', e);
    return null;
  }
}

export function clearQueuedSettings() {
  const storage = getStorage();
  if (!storage) return;
  try {
    storage.removeItem(KEY);
  } catch (e) {
    console.warn('[settingsOutbox] Failed to clear queued settings:', e);
  }
}

export default {
  enqueueSettings,
  getQueuedSettings,
  clearQueuedSettings,
};
